exports.components = {
  "component---src-templates-document-page-tsx": () => import("./../../../src/templates/DocumentPage.tsx" /* webpackChunkName: "component---src-templates-document-page-tsx" */),
  "component---src-templates-flexible-page-tsx": () => import("./../../../src/templates/FlexiblePage.tsx" /* webpackChunkName: "component---src-templates-flexible-page-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/Page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---src-templates-webform-page-tsx": () => import("./../../../src/templates/WebformPage.tsx" /* webpackChunkName: "component---src-templates-webform-page-tsx" */)
}

